import debounce from 'lodash.debounce';
import { useEffect } from 'react';
import { updateLastActiveAt } from '../api/sessionAPI';

const DEBOUNCE_MS = 3 * 60 * 1000;
const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
];

export function useActivityTracking(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    const debouncedUpdate = debounce(updateLastActiveAt, DEBOUNCE_MS, {
      leading: true,
      trailing: false,
    });

    const handler = () => debouncedUpdate();

    ACTIVITY_EVENTS.forEach((e) =>
      document.addEventListener(e, handler, { passive: true }),
    );

    return () => {
      ACTIVITY_EVENTS.forEach((e) => document.removeEventListener(e, handler));
      debouncedUpdate.cancel();
    };
  }, [enabled]);
}
